import { TrendingUp } from "lucide-react";
import {
  LamaMaturityTrendParamsSchema,
  defaultLamaMaturityTrendParams,
  type LamaMaturityTrendOutput,
  type LamaMaturityTrendParams,
} from "@playbookai/widget-schemas";
import { lamaParamsEditor } from "../lama-report-params/Editor.js";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { LamaMaturityTrendWidget } from "./Component.js";

/**
 * LAMA Maturity Trend — dashboard-only report section (plan §13.3).
 * `TView` is the `lama/maturity-trend@1` dataset output.
 */
export const lamaMaturityTrendDef: SqlWidgetDef<
  LamaMaturityTrendParams,
  LamaMaturityTrendOutput
> = {
  kind: "lamaMaturityTrend",
  label: "Maturity Trend",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 480, h: 280 },
  defaultParams: defaultLamaMaturityTrendParams,
  Component: LamaMaturityTrendWidget,
  storage: "sql",
  schema: LamaMaturityTrendParamsSchema,
  accent: "cyan",
  icon: TrendingUp,
  subtitle: "Overall maturity by wave",
  defaultRoster: false,
  category: "single",
  layout: { col: 0, row: 3, width: 480, height: 280 },
  dashboard: {
    icon: TrendingUp,
    defaultWidth: "wide",
    category: "Operations",
    supportsTitleOverride: true,
    EditorForm: lamaParamsEditor("lamaMaturityTrend"),
  },
};

registerWidget(lamaMaturityTrendDef);
